"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactGoogleMaps = require("react-google-maps");

var _SearchBox = _interopRequireDefault(require("react-google-maps/lib/components/places/SearchBox"));

var _types = require("../../types");

var _styles = _interopRequireDefault(require("./styles"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GoogleMaps = /*#__PURE__*/function (_PureComponent) {
  _inherits(GoogleMaps, _PureComponent);

  function GoogleMaps() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GoogleMaps);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GoogleMaps)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleMarkerRightClick", function (marker) {
      return _this.props.onMarkerRightClick(marker);
    });

    return _this;
  }

  _createClass(GoogleMaps, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onMapMounted = _this$props.onMapMounted,
          onMapClick = _this$props.onMapClick,
          center = _this$props.center,
          zoom = _this$props.zoom,
          usePolygon = _this$props.usePolygon,
          polygonPath = _this$props.polygonPath,
          onSearchBoxMounted = _this$props.onSearchBoxMounted,
          onPlacesChanged = _this$props.onPlacesChanged,
          placeholder = _this$props.placeholder,
          searchValue = _this$props.searchValue,
          onSearchChange = _this$props.onSearchChange,
          disabled = _this$props.disabled,
          markers = _this$props.markers,
          showOnlyMap = _this$props.showOnlyMap,
          colorPolygon = _this$props.colorPolygon,
          colorBorderPolygon = _this$props.colorBorderPolygon;
      var polygonOptions = (0, _constants.polygonDefaultOptions)(colorPolygon, colorBorderPolygon);
      return _react["default"].createElement(_reactGoogleMaps.GoogleMap, {
        ref: onMapMounted,
        defaultOptions: _constants.googleMapDefaultOptions,
        onClick: onMapClick,
        center: center,
        zoom: zoom
      }, usePolygon && _react["default"].createElement(_reactGoogleMaps.Polygon, {
        defaultOptions: polygonOptions,
        onClick: onMapClick,
        path: polygonPath
      }), !showOnlyMap && _react["default"].createElement(_SearchBox["default"], {
        ref: onSearchBoxMounted,
        controlPosition: window.google.maps.ControlPosition.TOP_LEFT,
        onPlacesChanged: onPlacesChanged
      }, _react["default"].createElement("input", {
        type: "text",
        placeholder: placeholder,
        style: _styles["default"].searchBox,
        value: searchValue,
        onChange: onSearchChange,
        disabled: disabled
      })), markers.map(function (marker) {
        return _react["default"].createElement(_reactGoogleMaps.Marker, _extends({}, marker, {
          key: marker.key,
          onRightClick: _this2.handleMarkerRightClick
        }));
      }));
    }
  }]);

  return GoogleMaps;
}(_react.PureComponent);

GoogleMaps.propTypes = _types.GoogleMapsPropTypes;

var _default = (0, _reactGoogleMaps.withGoogleMap)(GoogleMaps);

exports["default"] = _default;